
import ProgressDialog from "@/components/Base/ProgressDialog.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Game } from "@/models/Game";
import ChallengeBox from "@/components/Base/ChallengeBox.vue";
import { ChallengeData } from "@/models/Base/ChallengeData";
import { DropDownItem } from "@/models/Base/GlobalData";
import { Q_QUEST_TYPE } from "@/models/MapPois/Quest/QuestsEnum";

import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: { ProgressDialog, ChallengeBox },
})
class CreateQuest extends Vue {
  @Prop({ default: null }) readonly gameUid!: string;
  title = "";
  questType = 0;

  challengeData = {
    image: "",
    audio: { en: "" },
    video: { en: "" },
    text: "",
  } as ChallengeData;

  get getChallengeData(): ChallengeData {
    try {
      return this.challengeData;
    } catch (error) {
      console.log(error);
      return this.challengeData;
    }
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.gameUid
    );
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGame.gt_uid +
      "/seasons/" +
      this.getGame.seas_uid +
      "/img/quest/"
    );
  }

  get getQuestType(): DropDownItem[] {
    return [
      { value: Q_QUEST_TYPE.MAIN, text: "Main" },
      { value: Q_QUEST_TYPE.PRIMARY, text: "Primary" },
      { value: Q_QUEST_TYPE.SECONDARY, text: "Secondary" },
      { value: Q_QUEST_TYPE.MISC, text: "Misc" },
    ];
  }

  onDataChange(data: any): void {
    this.challengeData.text = data.text;
    this.challengeData.image = data.image;
    this.challengeData.audio = data.audio;
  }

  cancel(): void {
    this.$emit("closeDialog");
  }

  saveQuest(): void {
    this.$v.$touch();
    this.$emit("closeDialog");
    this.$bvModal.show("team-modal-spinner");
    var questData = {
      gameKey: this.gameUid,
      title: this.title,
      desc: this.challengeData.text,
      imgs: [this.challengeData.image],
      type: this.questType,
    };
    this.$store.dispatch("questStore/insertNewQuest", questData).then(() => {
      this.$bvModal.hide("team-modal-spinner");
    });
  }

  created(): void {
    this.$v.$touch();
  }

  @Validations()
  validations = {
    title: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(160),
    },
  };
}

export default CreateQuest;
